module.exports = __webpack_public_path__ + "img/eu_funds_2021-2027.ef458821.png";